"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo } from "react";
import { projectSlice } from "#/features/project/model/projectSlice";
import { usePlaygroundRoute } from "#/shared/hooks/usePlaygroundRoute";
import { buildPlaygroundPath } from "#/shared/lib/playgroundRoute";
import { removeLastPlaygroundPath, setLastPlaygroundPath } from "#/shared/local-storage/playgroundPath";
import { useAppDispatch } from "#/store/hooks";
export const usePlaygroundSlugs = () => {
  const $ = _c(32);
  const dispatch = useAppDispatch();
  const route = usePlaygroundRoute();
  let t0;
  let t1;
  if ($[0] !== route) {
    t0 = () => {
      if (!route?.slug[0]) {
        return;
      }
      setLastPlaygroundPath(route.pathname);
    };
    t1 = [route];
    $[0] = route;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  bb0: {
    if (!route) {
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          projectSlug: undefined,
          caseSlug: undefined,
          solutionSlug: undefined,
          setProject: _temp,
          setCase: _temp2,
          setSolution: _temp3,
          clearSlugs: _temp4
        };
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      t2 = t3 as const;
      break bb0;
    }
    const [projectSlug, caseSlug, solutionSlug] = route.slug;
    const {
      basePath,
      navigateTo
    } = route;
    let t3;
    if ($[4] !== basePath || $[5] !== dispatch || $[6] !== navigateTo) {
      t3 = slug => {
        dispatch(projectSlice.actions.loadStart());
        if (!slug) {
          return navigateTo(basePath, {
            replace: true,
            omitView: true
          });
        }
        return navigateTo(buildPlaygroundPath(basePath, [slug]), {
          replace: true,
          omitView: true
        });
      };
      $[4] = basePath;
      $[5] = dispatch;
      $[6] = navigateTo;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    const setProject = t3;
    let t4;
    if ($[8] !== basePath || $[9] !== caseSlug || $[10] !== navigateTo || $[11] !== projectSlug || $[12] !== setProject || $[13] !== solutionSlug) {
      t4 = slug_0 => {
        if (!projectSlug) {
          throw new Error("Project id must be set first");
        }
        if (!slug_0) {
          return setProject(projectSlug);
        }
        if (slug_0 === caseSlug) {
          return;
        }
        const caseSegments = solutionSlug ? [projectSlug, slug_0, solutionSlug] : [projectSlug, slug_0];
        return navigateTo(buildPlaygroundPath(basePath, caseSegments), {
          replace: !caseSlug
        });
      };
      $[8] = basePath;
      $[9] = caseSlug;
      $[10] = navigateTo;
      $[11] = projectSlug;
      $[12] = setProject;
      $[13] = solutionSlug;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    const setCase = t4;
    let t5;
    if ($[15] !== basePath || $[16] !== caseSlug || $[17] !== navigateTo || $[18] !== projectSlug || $[19] !== solutionSlug) {
      t5 = slug_1 => {
        if (!projectSlug || !caseSlug) {
          throw new Error("Project and case ids must be set first");
        }
        if (slug_1 === solutionSlug) {
          return;
        }
        return navigateTo(buildPlaygroundPath(basePath, [projectSlug, caseSlug, slug_1]), {
          replace: !solutionSlug
        });
      };
      $[15] = basePath;
      $[16] = caseSlug;
      $[17] = navigateTo;
      $[18] = projectSlug;
      $[19] = solutionSlug;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    const setSolution = t5;
    let t6;
    if ($[21] !== basePath || $[22] !== navigateTo) {
      t6 = () => {
        removeLastPlaygroundPath();
        return navigateTo(basePath, {
          omitView: true
        });
      };
      $[21] = basePath;
      $[22] = navigateTo;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    const clearSlugs = t6;
    let t7;
    if ($[24] !== caseSlug || $[25] !== clearSlugs || $[26] !== projectSlug || $[27] !== setCase || $[28] !== setProject || $[29] !== setSolution || $[30] !== solutionSlug) {
      t7 = {
        projectSlug,
        caseSlug,
        solutionSlug,
        setProject,
        setCase,
        setSolution,
        clearSlugs
      };
      $[24] = caseSlug;
      $[25] = clearSlugs;
      $[26] = projectSlug;
      $[27] = setCase;
      $[28] = setProject;
      $[29] = setSolution;
      $[30] = solutionSlug;
      $[31] = t7;
    } else {
      t7 = $[31];
    }
    t2 = t7 as const;
  }
  return t2;
};
function _temp() {}
function _temp2() {}
function _temp3() {}
function _temp4() {}